interface Contact {
   name: string;
   email: string;
   role?: string;
}

interface CheckAccessResult {
   hasAccess: boolean;
   contact?: Contact;
   error?: string;
}

export const checkAccess = (contacts: unknown): CheckAccessResult => {
   if (!Array.isArray(contacts) || contacts.length === 0) {
      return { hasAccess: false };
   }

   const primary = contacts[0] as Contact;

   if (!primary.email || !primary.name || primary.email === 'N/A' || primary.name === 'N/A') {
      return { hasAccess: false };
   }

   return { hasAccess: true, contact: primary };
};
